import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import { F as FeedbackFormField } from './FeedbackFormField-BQYTqZo2.js';
import { f as formatMessageHelper } from './i18n/formatMessageHelper-CMOV131q.js';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BGx4v_Uj-CJNeXUZQ.js';
import { S as SentimentScale } from '../internalComponents/SentimentScale/SentimentScale-B3zABql3.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const getOptions = ({
  externalOptions,
  variant,
  formatMessage
}) => {
  if (externalOptions) {
    return externalOptions;
  }
  if (variant === 'numeric-10') {
    const numeric10Options = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    return numeric10Options.map(level => ({
      id: `${level}`,
      label: formatMessage(formatMessageHelper('sentimentScaleForFeedbackFormNumericLabel'), {
        level,
        max: numeric10Options[numeric10Options.length - 1]
      })
    }));
  }
  return ['veryDissatisfied', 'dissatisfied', 'neitherSatisfiedNorDissatisfied', 'satisfied', 'verySatisfied'].map((optionId, index) => ({
    id: optionId,
    label: formatMessage(formatMessageHelper('sentimentScaleForFeedbackFormLabel'), {
      level: index + 1
    })
  }));
};
const SentimentScaleForFeedbackForm = ({
  validateOnMount,
  name,
  defaultValue,
  disabled,
  id,
  maxLabel: externalMaxLabel,
  minLabel: externalMinLabel,
  onChange,
  options: externalOptions,
  variant,
  ...sentimentScaleProps
}) => {
  const {
    formatMessage
  } = useIntl();
  const options = React__default.useMemo(() => getOptions({
    externalOptions,
    formatMessage,
    variant
  }), [externalOptions, formatMessage, variant]);
  const maxLabel = externalMaxLabel !== null && externalMaxLabel !== void 0 ? externalMaxLabel : variant === 'numeric-10' ? formatMessage(formatMessageHelper('sentimentScaleForFeedbackFormNumericMaxLabel')) : undefined;
  const minLabel = externalMinLabel !== null && externalMinLabel !== void 0 ? externalMinLabel : variant === 'numeric-10' ? formatMessage(formatMessageHelper('sentimentScaleForFeedbackFormNumericMinLabel')) : undefined;
  return /*#__PURE__*/React__default.createElement(FeedbackFormField, {
    validateOnMount: validateOnMount,
    name: name,
    id: id,
    defaultValue: defaultValue
  }, ({
    id: inputId,
    isSubmitting,
    error,
    onChange: internalOnChange,
    value: internalValue
  }) => {
    const errorMessage = error === null || error === void 0 ? void 0 : error.message;
    const handleChange = event => {
      internalOnChange(event.target.value);
      if (typeof onChange === 'function') {
        onChange(event);
      }
    };
    return /*#__PURE__*/React__default.createElement(SentimentScale, _extends({}, sentimentScaleProps, {
      disabled: disabled || isSubmitting,
      errorMessage: errorMessage,
      id: inputId,
      maxLabel: maxLabel,
      minLabel: minLabel,
      onChange: handleChange,
      options: options,
      value: internalValue,
      variant: variant
    }));
  });
};
SentimentScaleForFeedbackForm.propTypes = {
  defaultValue: PT.oneOfType([PT.string, PT.number]),
  disabled: PT.bool,
  errorMessage: PT.string,
  id: PT.string.isRequired,
  label: PT.string.isRequired,
  maxLabel: PT.string,
  minLabel: PT.string,
  name: PT.string.isRequired,
  onChange: PT.func,
  options: PT.arrayOf(PT.shape({
    id: PT.string.isRequired,
    label: PT.string.isRequired,
    disabled: PT.bool
  })),
  validateOnMount: PT.bool,
  value: PT.oneOfType([PT.string, PT.number]),
  variant: PT.oneOf(['emoji', 'numeric-5', 'numeric-10'])
};
SentimentScaleForFeedbackForm.defaultProps = {
  defaultValue: undefined,
  disabled: false,
  errorMessage: undefined,
  maxLabel: undefined,
  minLabel: undefined,
  onChange: noop,
  options: undefined,
  validateOnMount: true,
  value: undefined,
  variant: 'emoji'
};

export { SentimentScaleForFeedbackForm as S };
//# sourceMappingURL=SentimentScaleForFeedbackForm-y6FkxurJ.js.map
